// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bCreateGeneralMessagesView {
  position: relative;
  width: 100%;
  min-height: calc(100vh - var(--topbar-height, 64px));
  margin-top: 0 !important;
  padding: 0 0 32px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.gmComposerShell {
  width: min(1240px, 100%);
  max-width: 1240px;
  margin: 0 auto 0 0 !important;
  padding: 0 4px;
  align-self: flex-start;
  text-align: left;
}

.gmComposerShell > *,
.gmComposerCard,
.gmSettings,
.gmRecipientStep,
.gmContentV2,
.gmPreview,
.gmAffectedScreen {
  margin-right: 0;
  margin-left: 0;
}

.gmComposerHead {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.gmComposerHead__crest {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--blue-50, #eff6ff);
  color: var(--blue-700, #1d4ed8);
  font-weight: 800;
  flex: 0 0 auto;
}

.gmComposerHead__titles {
  min-width: 0;
  flex: 1 1 auto;
}

.gmComposerHead__title {
  font-size: 24px;
  line-height: 1.2;
  font-weight: 800;
  color: var(--text-strong, #0f172a);
}

.gmComposerHead__sub {
  margin-top: 3px;
  font-size: 13px;
  color: var(--text-muted, #64748b);
}

.gmCreateHeader {
  display: flex;
  width: calc(100% + 48px);
  min-height: 112px;
  align-items: center;
  gap: 14px;
  margin: -20px 0 16px -24px;
  padding: 13px 28px 12px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.gmCreateHeader__back {
  display: inline-flex;
  min-height: 34px;
  flex: 0 0 auto;
  align-items: center;
  gap: 5px;
  padding: 0 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font: inherit;
  font-size: 12.5px;
  font-weight: 750;
  cursor: pointer;
}

.gmCreateHeader__back:hover,
.gmCreateHeader__back:focus-visible {
  background: var(--blue-50, #eef6fc);
  outline: none;
}

.gmCreateHeader__back svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.gmCreateHeader > i {
  width: 1px;
  height: 50px;
  flex: 0 0 1px;
  background: var(--border-default, #cbd5e1);
}

.gmCreateHeader__main {
  min-width: 0;
  flex: 1 1 auto;
}

.gmCreateHeader h1 {
  overflow: hidden;
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 23px;
  font-weight: 800;
  line-height: 28px;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmCreateHeader__summary {
  display: flex;
  min-height: 24px;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  overflow-x: auto;
  scrollbar-width: none;
}

.gmCreateHeader__summary::-webkit-scrollbar {
  display: none;
}

.gmCreateHeader__summary > span,
.gmCreateHeader__step {
  display: inline-flex;
  min-height: 23px;
  flex: 0 0 auto;
  align-items: center;
  max-width: 320px;
  overflow: hidden;
  padding: 0 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 10.5px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmCreateHeader__status {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
}

.gmCreateHeader__saved {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.gmComposerLoading {
  display: flex;
  min-height: 260px;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  font-weight: 700;
}

.gmCreateHeader__summary .is-audience,
.gmCreateHeader__summary .is-recipients {
  border-color: #c9e0f1;
  background: #eef6fc;
  color: #155d8c;
}

.gmCreateHeader__summary .is-priority,
.gmCreateHeader__summary .is-schedule {
  border-color: #f3d49a;
  background: #fff7e8;
  color: #8b570a;
}

.gmCreateHeader__summary .is-channels,
.gmCreateHeader__summary .is-subject {
  border-color: #d9d1f3;
  background: #f5f2ff;
  color: #6548a8;
}

.gmCreateHeader__summary .is-attachments {
  border-color: #bfe5d0;
  background: #eefaf3;
  color: #287447;
}

.gmCreateHeader__summary .is-placeholder {
  color: var(--text-muted, #64748b);
}

.gmCreateHeader__step {
  min-height: 27px;
  padding: 0 10px;
  border-color: #c9e0f1;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11px;
  font-weight: 800;
}

.gmRecipientStep--compact .generalMessageRecipientsSelector {
  margin-top: 0;
}
.gmComposerCard {
  background: var(--surface-card, #fff);
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 18px;
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
  overflow: visible;
}

.gmComposerCard__top {
  padding: 18px 20px 0;
}

.gmComposerCard__body {
  padding: 12px 20px 20px;
}

.gmComposerActionsTop {
  display: flex;
  justify-content: flex-end;
}

.gmField {
  min-width: 0;
}

.gmField + .gmField,
.gmComposeFields .gmField + .gmField {
  margin-top: 16px;
}

.gmField__label {
  display: block;
  margin: 0 0 7px;
  font-size: 13px;
  line-height: 1.25;
  font-weight: 700;
  color: var(--text-body, #334155);
}

.gmField__rowLabel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 7px;
  flex-wrap: wrap;
}

.gmField__rowLabel .gmField__label {
  margin-bottom: 0;
}

.gmField__tools {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.gmField__hint {
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-muted, #64748b);
}

.gmInput,
.gmTextarea,
.gmVariableInput.vti {
  width: 100%;
  font-family: var(--font-body, inherit);
  font-size: 14px;
  color: var(--text-strong, #0f172a);
  background: var(--slate-0, #fff);
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.gmInput,
.gmVariableInput.vti {
  min-height: 42px;
  padding: 0 12px;
}

.gmTextarea {
  min-height: 150px;
  padding: 10px 12px;
  resize: vertical;
  line-height: 1.55;
}

.gmInput:focus,
.gmTextarea:focus,
.gmVariableInput.vti:focus,
.gmVariableInput.vti:focus-within {
  outline: none;
  border-color: var(--border-brand, #3b82f6);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(59, 130, 246, 0.18));
}

.gmSettings {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.gmSettings__grid {
  display: grid;
  grid-template-columns: minmax(220px, 320px) minmax(360px, 1fr) auto;
  gap: 12px;
  align-items: start;
}

.gmSettings__help {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 38px;
  padding-top: 0;
}

.gmSettings__section {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  padding: 14px;
  background: var(--slate-0, #fff);
}

.gmSettings__sectionHead {
  margin-bottom: 10px;
}

.gmSettings__sectionHead h4 {
  margin: 0;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 800;
  color: var(--text-strong, #0f172a);
}

.gmSettings__audienceGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.gmSettings__audience {
  position: relative;
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 36px;
  margin: 0;
  padding: 5px 32px 5px 7px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--slate-0, #fff);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.gmSettings__audience input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.gmSettings__audience:hover {
  border-color: var(--border-strong, #94a3b8);
}

.gmSettings__audience--readonly {
  cursor: default;
}

.gmSettings__audience--readonly:hover {
  border-color: var(--border-default, #cbd5e1);
}

.gmSettings__audience--readonly.gmSettings__audience--active:hover {
  border-color: var(--action-primary, #227ebd);
}

.gmSettings__audience--readonly:not(.gmSettings__audience--active) {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  box-shadow: none;
}

.gmSettings__audience--readonly:not(.gmSettings__audience--active) .gmSettings__audienceIcon {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-disabled, #94a3b8);
}

.gmSettings__audience--readonly:not(.gmSettings__audience--active) .gmSettings__audienceCopy strong {
  color: var(--text-disabled, #94a3b8);
}

.gmSettings__audience--active {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.gmSettings__audienceIcon {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--slate-100, #f1f5f9);
  color: var(--blue-700, #1d4ed8);
  font-size: 10px;
  font-weight: 800;
  flex: 0 0 auto;
}

.gmSettings__audienceCopy {
  min-width: 0;
  overflow: hidden;
}

.gmSettings__audienceCopy strong {
  display: block;
  overflow: hidden;
  font-size: 12.5px;
  line-height: 1.25;
  color: var(--text-strong, #0f172a);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmSettings__audienceCheck,
.gmPriority__check {
  position: absolute;
  top: 50%;
  right: 9px;
  width: 16px;
  height: 16px;
  transform: translateY(-50%);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  opacity: 0;
}

.gmSettings__audience--active .gmSettings__audienceCheck,
.gmPriority--active .gmPriority__check {
  opacity: 1;
}

.gmPriorities__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.gmPriority {
  position: relative;
  min-height: 36px;
  padding: 5px 30px 5px 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--slate-0, #fff);
  color: var(--text-body, #334155);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.gmPriority strong {
  display: block;
  overflow: hidden;
  font-size: 12.5px;
  line-height: 1.25;
  color: var(--text-strong, #0f172a);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmPriority--active {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.gmPriority:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.gmContentV2__topbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.gmContentV2__topbarActions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
}

.gmContentV2__topbarActions .sitHelpIconButton {
  margin-left: auto;
}

.gmComposeChannels {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.gmComposeChannel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1.5px solid var(--border-default, #cbd5e1);
  background: var(--slate-0, #fff);
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.gmComposeChannel[aria-disabled='true'] {
  cursor: not-allowed;
  opacity: 0.55;
}

.gmComposeChannel:hover {
  border-color: var(--border-strong, #94a3b8);
  color: var(--text-body, #334155);
}

.gmComposeChannel--on {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #1d4ed8);
}

.gmComposeChannel--active {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);
}

.gmComposeChannel__icon {
  display: inline-flex;
  flex: 0 0 14px;
  width: 14px;
  height: 14px;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 1;
  font-weight: 800;
  color: inherit;
}

.gmComposeChannel__icon svg {
  display: block;
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.gmComposeChannel__check {
  flex: 0 0 14px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
}

.gmComposeChannel__check svg {
  width: 12px;
  height: 12px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.gmComposeChannel__add {
  font-size: 11px;
  color: var(--text-subtle, #94a3b8);
  font-weight: 600;
}

.gmComposeCard {
  padding: 18px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
}

.gmStepHelp {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-height: 34px;
  margin-bottom: 10px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 600;
}

.gmRichText .ql-container {
  border-radius: 0 0 10px 10px;
  font-family: var(--font-body, inherit);
}

.gmRichText .ql-toolbar {
  border-radius: 10px 10px 0 0;
  background: var(--slate-50, #f8fafc);
}

.gmVarInsert {
  position: relative;
  display: inline-flex;
  z-index: 4;
}

.gmVarInsert__button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid var(--blue-200, #bfdbfe);
  background: var(--slate-0, #fff);
  color: var(--blue-700, #1d4ed8);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.gmVarInsert__button:hover {
  background: var(--blue-50, #eff6ff);
}

.gmVarInsert__hash {
  font-weight: 900;
}

.gmVarInsert__panel {
  position: absolute;
  z-index: 80;
  top: calc(100% + 7px);
  right: 0;
  width: min(340px, 86vw);
  padding: 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-lg, 0 18px 44px rgba(15, 23, 42, 0.16));
}

.gmVarInsert__hint {
  margin-bottom: 10px;
  font-size: 11px;
  color: var(--text-muted, #64748b);
}

.gmVarGroup {
  margin-bottom: 10px;
}

.gmVarGroup:last-child {
  margin-bottom: 0;
}

.gmVarGroup__title {
  margin-bottom: 5px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.gmVarGroup__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.gmVarChip {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border: 1px solid transparent;
  border-radius: 7px;
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.gmVarChip:hover {
  opacity: 0.8;
}

.gmDropzone {
  position: relative;
  min-height: 62px;
  margin: 0;
  border: 1.5px dashed var(--border-default, #cbd5e1);
  border-radius: 12px;
  background: var(--slate-25, #fbfdff);
  color: var(--text-muted, #64748b);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.gmDropzone:hover {
  border-color: var(--blue-400, #60a5fa);
  background: var(--blue-50, #eff6ff);
  color: var(--blue-700, #1d4ed8);
}

.gmDropzone input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.gmDropzone__icon,
.gmAttachment__icon {
  font-size: 11px;
  font-weight: 800;
}

.gmAttachment {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  padding: 9px 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--slate-25, #fbfdff);
}

.gmAttachment__name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--text-body, #334155);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmAttachment__size {
  font-size: 12px;
  color: var(--text-muted, #64748b);
  font-family: var(--font-mono, monospace);
}

.gmAttachment button,
.gmErrorInline button {
  border: none;
  background: transparent;
  color: var(--red-600, #dc2626);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.gmSmsCount {
  margin-top: 7px;
  font-size: 12px;
  color: var(--text-muted, #64748b);
}

.gmSmsCount b {
  color: var(--text-body, #334155);
}

.gmBanner {
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

.gmBanner--warning {
  border: 1px solid var(--amber-200, #fde68a);
  background: var(--amber-50, #fffbeb);
  color: var(--amber-800, #92400e);
}

.gmChildVariableWarning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 18px;
  line-height: 1.45;
}

.gmChildVariableWarning strong {
  flex: 0 0 auto;
}

.gmErrorInline {
  margin-top: 8px;
  padding: 9px 12px;
  border-radius: 10px;
  background: var(--red-50, #fef2f2);
  color: var(--red-700, #b91c1c);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  font-weight: 700;
}

.gmButton,
.gmComposerButtons button,
.gmActionButton,
.gmActionDropdown button {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 15px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.gmButton--primary,
.gmComposerButtons .gmButton--primary,
.gmActionButton--primary {
  background: var(--action-primary, #2563eb);
  border-color: var(--action-primary, #2563eb);
  color: #fff;
}

.gmButton--primary:hover,
.gmActionButton--primary:hover {
  background: var(--blue-700, #1d4ed8);
  border-color: var(--blue-700, #1d4ed8);
}

.gmButton--secondary,
.gmComposerButtons .gmButton--secondary {
  background: var(--slate-0, #fff);
  border-color: var(--border-default, #cbd5e1);
  color: var(--text-body, #334155);
}

.gmButton--ghost,
.gmComposerButtons .gmButton--ghost {
  border-color: transparent;
  background: transparent;
  color: var(--text-body, #334155);
}

.gmButton--ghost:hover,
.gmComposerButtons .gmButton--ghost:hover {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.gmButton--secondary:hover,
.gmComposerButtons .gmButton--secondary:hover {
  border-color: var(--border-strong, #94a3b8);
  background: var(--slate-50, #f8fafc);
}

.gmButton:disabled,
.gmComposerButtons button:disabled,
.gmActionButton:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.gmComposerButtons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.gmComposerButtons__left,
.gmComposerButtons__right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.gmComposerButtons__final {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.gmScheduleField {
  position: relative;
  z-index: 20;
  width: min(100%, 420px);
  margin: 16px 0;
  padding: 16px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
}

.gmScheduleField .sit-dp__pop {
  z-index: 1200;
}

.gmActionWrap {
  position: relative;
  display: inline-flex;
}

.gmActionGroup {
  display: inline-flex;
  border-radius: 999px;
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.08));
}

.gmActionButton {
  border-radius: 999px 0 0 999px;
}

.gmActionToggle {
  min-width: 36px;
  padding: 0 12px;
  border-radius: 0 999px 999px 0;
  border-left-color: rgba(255, 255, 255, 0.34);
}

.gmActionDropdown {
  position: absolute;
  z-index: 50;
  top: calc(100% + 8px);
  right: 0;
  min-width: 190px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-lg, 0 18px 44px rgba(15, 23, 42, 0.16));
}

.gmActionDropdown button {
  width: 100%;
  justify-content: flex-start;
  min-height: 34px;
  border-radius: 8px;
  background: transparent;
  color: var(--text-body, #334155);
}

.gmActionDropdown button:hover {
  background: var(--slate-100, #f1f5f9);
}

.bProgress {
  height: 8px;
  border-radius: 999px;
  background: var(--slate-100, #f1f5f9);
  overflow: visible;
  margin: 0;
}

.bProgress .progress-bar {
  height: 8px;
  border-radius: 999px;
  background: var(--action-primary, #2563eb);
  color: transparent;
  min-width: 8px;
}

.gmProgressText {
  margin-top: 8px;
  font-size: 12px;
  color: var(--text-muted, #64748b);
  font-weight: 700;
}

.gmPreview {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 390px;
  gap: 20px;
  align-items: start;
}

.gmPreview__main,
.gmPreview__recipients {
  min-width: 0;
}

.gmPreview__title {
  margin: 0;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-subtle, #94a3b8);
}

.gmPreview__heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.gmPreview__heading .sitHelpIconButton {
  margin-left: auto;
}

.gmPreviewTabs {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.gmPreviewTabs__tab {
  min-height: 34px;
  padding: 7px 12px;
  border-radius: 999px;
  border: 1.5px solid var(--border-default, #cbd5e1);
  background: var(--slate-0, #fff);
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.gmPreviewTabs__tab--active {
  border-color: var(--action-primary, #2563eb);
  background: var(--blue-50, #eff6ff);
  color: var(--blue-700, #1d4ed8);
}

.gmPreviewCard {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  overflow: hidden;
}

.gmPreviewEmail__head {
  padding: 13px 15px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
}

.gmPreviewEmail__from {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 12px;
  color: var(--text-muted, #64748b);
}

.gmPreviewEmail__fromLabel {
  color: var(--text-subtle, #94a3b8);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.gmPreviewEmail__from strong {
  color: var(--text-strong, #0f172a);
  font-weight: 700;
}

.gmPreviewEmail__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--blue-100, #dbeafe);
  color: var(--blue-700, #1d4ed8);
  font-weight: 800;
}

.gmPreviewEmail__subject {
  margin-top: 9px;
  font-size: 15px;
  font-weight: 800;
  color: var(--text-strong, #0f172a);
}

.gmPreviewEmail__body {
  padding: 16px 15px;
  min-height: 160px;
  line-height: 1.6;
  font-size: 13px;
  color: var(--text-body, #334155);
  overflow-wrap: anywhere;
}

.gmPreviewEmail__body img {
  max-width: 100% !important;
  height: auto !important;
}

.gmPreviewEmail__attachments {
  padding: 12px 15px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fbfdff);
  font-size: 12px;
}

.gmPreviewDevice {
  max-width: 360px;
  margin: 0 auto;
  border-radius: 20px;
  padding: 16px 14px 20px;
  background: linear-gradient(160deg, #1e293b, #334155);
}

.gmPreviewDevice__time {
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 12px;
}

.gmPreviewPushCard {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 14px;
  padding: 11px 12px;
  box-shadow: var(--shadow-md, 0 8px 20px rgba(15, 23, 42, 0.14));
}

.gmPreviewPushCard__top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.gmPreviewPushCard__logo {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  object-fit: contain;
  background: #fff;
}

.gmPreviewPushCard__app {
  flex: 1;
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted, #64748b);
  text-transform: uppercase;
}

.gmPreviewPushCard__now {
  font-size: 11px;
  color: var(--text-subtle, #94a3b8);
}

.gmPreviewPushCard__title {
  font-size: 13px;
  font-weight: 800;
  color: var(--text-strong, #0f172a);
}

.gmPreviewPushCard__body {
  margin-top: 2px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-body, #334155);
}

.gmPreviewSms {
  padding: 16px 14px;
  border-radius: 14px;
  background: var(--slate-100, #f1f5f9);
}

.gmPreviewSms__sender {
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-muted, #64748b);
  margin-bottom: 12px;
}

.gmPreviewSms__bubble {
  max-width: 86%;
  padding: 10px 13px;
  border-radius: 16px 16px 16px 4px;
  background: var(--green-500, #22c55e);
  color: #fff;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.gmPreviewSms__time {
  margin-top: 6px;
  font-size: 11px;
  color: var(--text-subtle, #94a3b8);
}

@media (max-width: 1100px) {
  .gmSettings__audienceGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .gmPreview {
    grid-template-columns: 1fr;
  }
}

.gmComposerInlineError {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 18px;
  padding: 11px 12px;
  border: 1px solid #fecaca;
  border-radius: 12px;
  background: #fff7f7;
  color: #991b1b;
}

.gmComposerInlineError__icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fee2e2;
  font-size: 13px;
  font-weight: 900;
}

.gmComposerInlineError p {
  flex: 1 1 auto;
  margin: 0;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.45;
}

.gmComposerInlineError__actions {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.gmComposerInlineError__close {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #991b1b;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.gmComposerInlineError__close:hover {
  background: #fee2e2;
}

@media (max-width: 1217px) {
  .gmCreateHeader {
    width: 100vw;
    margin-left: -12px;
  }
}

@media (max-width: 900px) {
  .gmCreateHeader {
    width: 100vw;
    min-height: 104px;
    align-items: flex-start;
    margin: -16px 0 14px -16px;
    padding: 12px 16px;
  }

  .gmCreateHeader > i,
  .gmCreateHeader__status {
    display: none;
  }

  .gmCreateHeader__back {
    padding-right: 3px;
    padding-left: 3px;
  }

  .gmCreateHeader h1 {
    font-size: 20px;
    line-height: 25px;
  }
}

@media (max-width: 760px) {
  .bCreateGeneralMessagesView {
    padding-bottom: 24px;
  }

  .gmComposerHead {
    align-items: flex-start;
  }

  .gmSettings__grid,
  .gmSettings__audienceGrid,
  .gmPriorities__grid {
    grid-template-columns: 1fr;
  }

  .gmSettings__help {
    min-height: 28px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .gmAffected__header {
    align-items: flex-start;
  }

  .gmAffected__help > span,
  .gmAffected__summaryDivider {
    display: none;
  }

  .gmComposerCard--recipients .gmComposerCard__body {
    padding: 14px;
  }

  .gmComposerButtons {
    flex-direction: column;
  }

  .gmComposerButtons__left,
  .gmComposerButtons__right,
  .gmComposerButtons button {
    width: 100%;
  }
}

/* Follow-up alignment and overflow fixes */
.gmSettings__grid .gmField + .gmField {
  margin-top: 0;
}

.gmField {
  position: relative;
}

.gmField:focus-within {
  z-index: 120;
}

.gmVarInsert:focus-within,
.gmVarInsert:hover {
  z-index: 140;
}

.gmVarInsert__panel {
  z-index: 1000;
}

.gmButton,
.gmComposerButtons button,
.gmActionButton,
.gmActionDropdown button {
  border-radius: 10px;
}

.gmActionGroup {
  border-radius: 10px;
}

.gmActionButton {
  border-radius: 10px 0 0 10px;
}

.gmActionToggle {
  border-radius: 0 10px 10px 0;
}

.gmActionDropdown button {
  border-radius: 8px;
}

.gmPreview__recipients {
  overflow: hidden;
}

.gmRecipientsReview {
  min-width: 0;
  padding: 0;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  overflow: hidden;
}

.gmAffected__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 14px;
}

.gmAffected__header h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-size: 26px;
  line-height: 1.2;
  font-weight: 800;
}

.gmAffected__header p {
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 14px;
}

.gmAffected__help {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
}

.gmAffected__summary {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 24px 14px;
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--surface-sunken, #f8fafc);
  flex-wrap: wrap;
}

.gmAffected__summary > strong,
.gmAffected__totalMetric {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  padding: 4px 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.gmAffected__totalMetric {
  cursor: pointer;
}

.gmAffected__totalMetric.is-active {
  border-color: var(--blue-500, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.gmAffected__summaryDivider {
  width: 1px;
  height: 22px;
  background: var(--border-default, #cbd5e1);
}

.gmAffected__summaryChannels {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.gmAffected__summaryChannels > span,
.gmAffected__summaryChannels > button {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 6px;
  padding: 3px 9px 3px 4px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.gmAffected__summaryChannels > button {
  cursor: pointer;
}

.gmAffected__summaryChannels > button:hover:not(:disabled) {
  border-color: var(--border-default, #cbd5e1);
  background: var(--blue-50, #eef6fc);
}

.gmAffected__summaryChannels > button.is-active {
  border-color: var(--blue-500, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.gmAffected__summaryChannels > button:disabled {
  cursor: default;
  opacity: 0.62;
}

.gmAffected__summaryChannels > em,
.gmAffected__delivery {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.gmAffected__summaryChannels > em {
  min-height: 30px;
  padding-right: 10px;
  padding-left: 10px;
  background: var(--amber-100, #fef3c7);
  color: var(--amber-800, #92400e);
  white-space: nowrap;
}

.gmAffected__summaryChannels > button.is-no-channels {
  padding-right: 10px;
  padding-left: 10px;
  background: var(--amber-100, #fef3c7);
  color: var(--amber-800, #92400e);
}

.gmAffected__summaryChannels > button.is-no-channels.is-active {
  border-color: #f3c46b;
  background: #ffe9c2;
}

.gmAffected__loadButton {
  min-height: 34px;
  margin-left: auto;
  white-space: nowrap;
}

.gmAffected__channel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
}

.gmAffected__channel--active {
  background: var(--status-success-bg, #dcfce7);
  color: var(--status-success-fg, #15803d);
}

.gmAffected__loading,
.gmAffected__empty,
.gmAffected__emptyText {
  margin: 0 24px 20px;
  padding: 18px;
  border-radius: 12px;
  background: var(--surface-sunken, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.gmAffected__recipient {
  display: flex;
  align-items: center;
  gap: 10px;
}

.gmAffected__recipient > strong {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 650;
}

.gmAffected__roles {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.gmAffected__roles > span {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11px;
  font-weight: 750;
  white-space: nowrap;
}

.gmAffected__roles > span.is-unknown {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.gmAffected__listMeta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 24px 10px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
}

.gmAffected__listMeta button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.gmAffected__listMeta button:hover {
  text-decoration: underline;
}

.gmAffected__avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 50%;
  background: var(--blue-100, #dbeafe);
  color: var(--blue-700, #1d4ed8);
  font-size: 11px;
  font-weight: 800;
  flex: 0 0 auto;
}

.gmAffected__avatar img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gmAffected__delivery--success {
  background: var(--status-success-bg, #dcfce7);
  color: var(--status-success-fg, #15803d);
}

.gmAffected__delivery--danger {
  background: var(--status-danger-bg, #fee2e2);
  color: var(--status-danger-fg, #b91c1c);
}

.gmAffected__channelCell {
  width: 90px;
  text-align: center !important;
}

.gmAffected__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
}

.gmAffected__head span,
.gmAffected__empty,
.gmAffected__emptyText {
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.gmAffected__empty {
  margin-top: 10px;
}

.gmAffected__empty p {
  margin: 0 0 10px;
  line-height: 1.45;
}

.gmAffected__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.gmAffected__stats span {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 9px;
  border-radius: 8px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.gmAffected__tableWrap {
  width: 100%;
  max-width: 100%;
  max-height: 420px;
  margin: 0 24px 20px;
  width: auto;
  overflow: auto;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
}

.gmAffected__table {
  width: 100%;
  min-width: 720px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 12px;
}

.gmAffected__table th,
.gmAffected__table td {
  padding: 11px 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  text-align: left;
  vertical-align: top;
  overflow-wrap: anywhere;
}

.gmAffected__table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.gmAffected__table tr:last-child td {
  border-bottom: 0;
}

.gmAffected__channel svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.gmComposerCard--recipients .gmAffected__table tbody tr:nth-child(even) {
  background: var(--slate-50, #f8fafc);
}

.gmPreview--single {
  grid-template-columns: minmax(0, 1fr);
}

.gmAffectedScreen {
  width: min(1100px, 100%);
  max-width: 1100px;
  margin: 0;
}

.gmComposerCard--recipients {
  width: min(1100px, 100%);
  max-width: 1100px;
  margin: 0;
}

.gmComposerCard--recipients .gmComposerCard__body {
  padding: 24px 28px;
}

.gmComposerCard--recipients .gmRecipientsReview {
  border: 0;
  border-radius: 0;
  overflow: visible;
}

.gmComposerCard--recipients .gmAffected__header {
  padding: 0 0 20px;
}

.gmComposerCard--recipients .gmAffected__summary,
.gmComposerCard--recipients .gmAffected__listMeta,
.gmComposerCard--recipients .gmAffected__tableWrap,
.gmComposerCard--recipients .gmAffected__loading,
.gmComposerCard--recipients .gmAffected__empty,
.gmComposerCard--recipients .gmAffected__emptyText {
  margin-right: 0;
  margin-left: 0;
}

.gmAffectedScreen .gmAffected__tableWrap {
  max-height: 560px;
}

.gmAffectedScreen .gmAffected__table {
  min-width: 760px;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Communications/GeneralMessages/CreateGeneralMessageView/CreateGeneralMessageView.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,oDAAoD;EACpD,wBAAwB;EACxB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,oBAAoB;EACpB,0CAA0C;EAC1C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,mBAAmB;EACnB,8DAA8D;EAC9D,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;;;EAGE,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,kCAAkC;EAClC,gCAAgC;EAChC,gDAAgD;EAChD,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,gDAAgD;EAChD,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gDAAgD;EAChD,oBAAoB;EACpB,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kDAAkD;EAClD,gCAAgC;EAChC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,mDAAmD;EACnD,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mGAAmG;AACrG;;AAEA;;;EAGE,0CAA0C;EAC1C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE,gCAAgC;EAChC,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;;EAEE,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kDAAkD;EAClD,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,oBAAoB;EACpB,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,+CAA+C;EAC/C,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;;EAGE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".bCreateGeneralMessagesView {\n  position: relative;\n  width: 100%;\n  min-height: calc(100vh - var(--topbar-height, 64px));\n  margin-top: 0 !important;\n  padding: 0 0 32px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.gmComposerShell {\n  width: min(1240px, 100%);\n  max-width: 1240px;\n  margin: 0 auto 0 0 !important;\n  padding: 0 4px;\n  align-self: flex-start;\n  text-align: left;\n}\n\n.gmComposerShell > *,\n.gmComposerCard,\n.gmSettings,\n.gmRecipientStep,\n.gmContentV2,\n.gmPreview,\n.gmAffectedScreen {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.gmComposerHead {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.gmComposerHead__crest {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--blue-50, #eff6ff);\n  color: var(--blue-700, #1d4ed8);\n  font-weight: 800;\n  flex: 0 0 auto;\n}\n\n.gmComposerHead__titles {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.gmComposerHead__title {\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 800;\n  color: var(--text-strong, #0f172a);\n}\n\n.gmComposerHead__sub {\n  margin-top: 3px;\n  font-size: 13px;\n  color: var(--text-muted, #64748b);\n}\n\n.gmCreateHeader {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 112px;\n  align-items: center;\n  gap: 14px;\n  margin: -20px 0 16px -24px;\n  padding: 13px 28px 12px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.gmCreateHeader__back {\n  display: inline-flex;\n  min-height: 34px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 5px;\n  padding: 0 8px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.gmCreateHeader__back:hover,\n.gmCreateHeader__back:focus-visible {\n  background: var(--blue-50, #eef6fc);\n  outline: none;\n}\n\n.gmCreateHeader__back svg {\n  width: 15px;\n  height: 15px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.gmCreateHeader > i {\n  width: 1px;\n  height: 50px;\n  flex: 0 0 1px;\n  background: var(--border-default, #cbd5e1);\n}\n\n.gmCreateHeader__main {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.gmCreateHeader h1 {\n  overflow: hidden;\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 23px;\n  font-weight: 800;\n  line-height: 28px;\n  letter-spacing: -0.015em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmCreateHeader__summary {\n  display: flex;\n  min-height: 24px;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.gmCreateHeader__summary::-webkit-scrollbar {\n  display: none;\n}\n\n.gmCreateHeader__summary > span,\n.gmCreateHeader__step {\n  display: inline-flex;\n  min-height: 23px;\n  flex: 0 0 auto;\n  align-items: center;\n  max-width: 320px;\n  overflow: hidden;\n  padding: 0 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 10.5px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmCreateHeader__status {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 7px;\n}\n\n.gmCreateHeader__saved {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.gmComposerLoading {\n  display: flex;\n  min-height: 260px;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.gmCreateHeader__summary .is-audience,\n.gmCreateHeader__summary .is-recipients {\n  border-color: #c9e0f1;\n  background: #eef6fc;\n  color: #155d8c;\n}\n\n.gmCreateHeader__summary .is-priority,\n.gmCreateHeader__summary .is-schedule {\n  border-color: #f3d49a;\n  background: #fff7e8;\n  color: #8b570a;\n}\n\n.gmCreateHeader__summary .is-channels,\n.gmCreateHeader__summary .is-subject {\n  border-color: #d9d1f3;\n  background: #f5f2ff;\n  color: #6548a8;\n}\n\n.gmCreateHeader__summary .is-attachments {\n  border-color: #bfe5d0;\n  background: #eefaf3;\n  color: #287447;\n}\n\n.gmCreateHeader__summary .is-placeholder {\n  color: var(--text-muted, #64748b);\n}\n\n.gmCreateHeader__step {\n  min-height: 27px;\n  padding: 0 10px;\n  border-color: #c9e0f1;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.gmRecipientStep--compact .generalMessageRecipientsSelector {\n  margin-top: 0;\n}\n.gmComposerCard {\n  background: var(--surface-card, #fff);\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 18px;\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n  overflow: visible;\n}\n\n.gmComposerCard__top {\n  padding: 18px 20px 0;\n}\n\n.gmComposerCard__body {\n  padding: 12px 20px 20px;\n}\n\n.gmComposerActionsTop {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.gmField {\n  min-width: 0;\n}\n\n.gmField + .gmField,\n.gmComposeFields .gmField + .gmField {\n  margin-top: 16px;\n}\n\n.gmField__label {\n  display: block;\n  margin: 0 0 7px;\n  font-size: 13px;\n  line-height: 1.25;\n  font-weight: 700;\n  color: var(--text-body, #334155);\n}\n\n.gmField__rowLabel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 7px;\n  flex-wrap: wrap;\n}\n\n.gmField__rowLabel .gmField__label {\n  margin-bottom: 0;\n}\n\n.gmField__tools {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.gmField__hint {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--text-muted, #64748b);\n}\n\n.gmInput,\n.gmTextarea,\n.gmVariableInput.vti {\n  width: 100%;\n  font-family: var(--font-body, inherit);\n  font-size: 14px;\n  color: var(--text-strong, #0f172a);\n  background: var(--slate-0, #fff);\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 10px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.gmInput,\n.gmVariableInput.vti {\n  min-height: 42px;\n  padding: 0 12px;\n}\n\n.gmTextarea {\n  min-height: 150px;\n  padding: 10px 12px;\n  resize: vertical;\n  line-height: 1.55;\n}\n\n.gmInput:focus,\n.gmTextarea:focus,\n.gmVariableInput.vti:focus,\n.gmVariableInput.vti:focus-within {\n  outline: none;\n  border-color: var(--border-brand, #3b82f6);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(59, 130, 246, 0.18));\n}\n\n.gmSettings {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.gmSettings__grid {\n  display: grid;\n  grid-template-columns: minmax(220px, 320px) minmax(360px, 1fr) auto;\n  gap: 12px;\n  align-items: start;\n}\n\n.gmSettings__help {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  min-height: 38px;\n  padding-top: 0;\n}\n\n.gmSettings__section {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  padding: 14px;\n  background: var(--slate-0, #fff);\n}\n\n.gmSettings__sectionHead {\n  margin-bottom: 10px;\n}\n\n.gmSettings__sectionHead h4 {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.25;\n  font-weight: 800;\n  color: var(--text-strong, #0f172a);\n}\n\n.gmSettings__audienceGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.gmSettings__audience {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 36px;\n  margin: 0;\n  padding: 5px 32px 5px 7px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--slate-0, #fff);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.gmSettings__audience input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.gmSettings__audience:hover {\n  border-color: var(--border-strong, #94a3b8);\n}\n\n.gmSettings__audience--readonly {\n  cursor: default;\n}\n\n.gmSettings__audience--readonly:hover {\n  border-color: var(--border-default, #cbd5e1);\n}\n\n.gmSettings__audience--readonly.gmSettings__audience--active:hover {\n  border-color: var(--action-primary, #227ebd);\n}\n\n.gmSettings__audience--readonly:not(.gmSettings__audience--active) {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  box-shadow: none;\n}\n\n.gmSettings__audience--readonly:not(.gmSettings__audience--active) .gmSettings__audienceIcon {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-disabled, #94a3b8);\n}\n\n.gmSettings__audience--readonly:not(.gmSettings__audience--active) .gmSettings__audienceCopy strong {\n  color: var(--text-disabled, #94a3b8);\n}\n\n.gmSettings__audience--active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n.gmSettings__audienceIcon {\n  width: 23px;\n  height: 23px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--blue-700, #1d4ed8);\n  font-size: 10px;\n  font-weight: 800;\n  flex: 0 0 auto;\n}\n\n.gmSettings__audienceCopy {\n  min-width: 0;\n  overflow: hidden;\n}\n\n.gmSettings__audienceCopy strong {\n  display: block;\n  overflow: hidden;\n  font-size: 12.5px;\n  line-height: 1.25;\n  color: var(--text-strong, #0f172a);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmSettings__audienceCheck,\n.gmPriority__check {\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  width: 16px;\n  height: 16px;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 800;\n  opacity: 0;\n}\n\n.gmSettings__audience--active .gmSettings__audienceCheck,\n.gmPriority--active .gmPriority__check {\n  opacity: 1;\n}\n\n.gmPriorities__grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.gmPriority {\n  position: relative;\n  min-height: 36px;\n  padding: 5px 30px 5px 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--slate-0, #fff);\n  color: var(--text-body, #334155);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.gmPriority strong {\n  display: block;\n  overflow: hidden;\n  font-size: 12.5px;\n  line-height: 1.25;\n  color: var(--text-strong, #0f172a);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmPriority--active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n.gmPriority:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.gmContentV2__topbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.gmContentV2__topbarActions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 auto;\n}\n\n.gmContentV2__topbarActions .sitHelpIconButton {\n  margin-left: auto;\n}\n\n.gmComposeChannels {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.gmComposeChannel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 32px;\n  padding: 0 10px;\n  border-radius: 999px;\n  border: 1.5px solid var(--border-default, #cbd5e1);\n  background: var(--slate-0, #fff);\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.gmComposeChannel[aria-disabled='true'] {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.gmComposeChannel:hover {\n  border-color: var(--border-strong, #94a3b8);\n  color: var(--text-body, #334155);\n}\n\n.gmComposeChannel--on {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #1d4ed8);\n}\n\n.gmComposeChannel--active {\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);\n}\n\n.gmComposeChannel__icon {\n  display: inline-flex;\n  flex: 0 0 14px;\n  width: 14px;\n  height: 14px;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  line-height: 1;\n  font-weight: 800;\n  color: inherit;\n}\n\n.gmComposeChannel__icon svg {\n  display: block;\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.gmComposeChannel__check {\n  flex: 0 0 14px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.gmComposeChannel__check svg {\n  width: 12px;\n  height: 12px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2.6;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.gmComposeChannel__add {\n  font-size: 11px;\n  color: var(--text-subtle, #94a3b8);\n  font-weight: 600;\n}\n\n.gmComposeCard {\n  padding: 18px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n}\n\n.gmStepHelp {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  min-height: 34px;\n  margin-bottom: 10px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.gmRichText .ql-container {\n  border-radius: 0 0 10px 10px;\n  font-family: var(--font-body, inherit);\n}\n\n.gmRichText .ql-toolbar {\n  border-radius: 10px 10px 0 0;\n  background: var(--slate-50, #f8fafc);\n}\n\n.gmVarInsert {\n  position: relative;\n  display: inline-flex;\n  z-index: 4;\n}\n\n.gmVarInsert__button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 28px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--blue-200, #bfdbfe);\n  background: var(--slate-0, #fff);\n  color: var(--blue-700, #1d4ed8);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gmVarInsert__button:hover {\n  background: var(--blue-50, #eff6ff);\n}\n\n.gmVarInsert__hash {\n  font-weight: 900;\n}\n\n.gmVarInsert__panel {\n  position: absolute;\n  z-index: 80;\n  top: calc(100% + 7px);\n  right: 0;\n  width: min(340px, 86vw);\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-lg, 0 18px 44px rgba(15, 23, 42, 0.16));\n}\n\n.gmVarInsert__hint {\n  margin-bottom: 10px;\n  font-size: 11px;\n  color: var(--text-muted, #64748b);\n}\n\n.gmVarGroup {\n  margin-bottom: 10px;\n}\n\n.gmVarGroup:last-child {\n  margin-bottom: 0;\n}\n\n.gmVarGroup__title {\n  margin-bottom: 5px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.gmVarGroup__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.gmVarChip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 9px;\n  border: 1px solid transparent;\n  border-radius: 7px;\n  font-family: var(--font-mono, monospace);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gmVarChip:hover {\n  opacity: 0.8;\n}\n\n.gmDropzone {\n  position: relative;\n  min-height: 62px;\n  margin: 0;\n  border: 1.5px dashed var(--border-default, #cbd5e1);\n  border-radius: 12px;\n  background: var(--slate-25, #fbfdff);\n  color: var(--text-muted, #64748b);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.gmDropzone:hover {\n  border-color: var(--blue-400, #60a5fa);\n  background: var(--blue-50, #eff6ff);\n  color: var(--blue-700, #1d4ed8);\n}\n\n.gmDropzone input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.gmDropzone__icon,\n.gmAttachment__icon {\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.gmAttachment {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--slate-25, #fbfdff);\n}\n\n.gmAttachment__name {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-body, #334155);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmAttachment__size {\n  font-size: 12px;\n  color: var(--text-muted, #64748b);\n  font-family: var(--font-mono, monospace);\n}\n\n.gmAttachment button,\n.gmErrorInline button {\n  border: none;\n  background: transparent;\n  color: var(--red-600, #dc2626);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gmSmsCount {\n  margin-top: 7px;\n  font-size: 12px;\n  color: var(--text-muted, #64748b);\n}\n\n.gmSmsCount b {\n  color: var(--text-body, #334155);\n}\n\n.gmBanner {\n  padding: 12px 14px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.gmBanner--warning {\n  border: 1px solid var(--amber-200, #fde68a);\n  background: var(--amber-50, #fffbeb);\n  color: var(--amber-800, #92400e);\n}\n\n.gmChildVariableWarning {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 18px;\n  line-height: 1.45;\n}\n\n.gmChildVariableWarning strong {\n  flex: 0 0 auto;\n}\n\n.gmErrorInline {\n  margin-top: 8px;\n  padding: 9px 12px;\n  border-radius: 10px;\n  background: var(--red-50, #fef2f2);\n  color: var(--red-700, #b91c1c);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.gmButton,\n.gmComposerButtons button,\n.gmActionButton,\n.gmActionDropdown button {\n  min-height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 15px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.gmButton--primary,\n.gmComposerButtons .gmButton--primary,\n.gmActionButton--primary {\n  background: var(--action-primary, #2563eb);\n  border-color: var(--action-primary, #2563eb);\n  color: #fff;\n}\n\n.gmButton--primary:hover,\n.gmActionButton--primary:hover {\n  background: var(--blue-700, #1d4ed8);\n  border-color: var(--blue-700, #1d4ed8);\n}\n\n.gmButton--secondary,\n.gmComposerButtons .gmButton--secondary {\n  background: var(--slate-0, #fff);\n  border-color: var(--border-default, #cbd5e1);\n  color: var(--text-body, #334155);\n}\n\n.gmButton--ghost,\n.gmComposerButtons .gmButton--ghost {\n  border-color: transparent;\n  background: transparent;\n  color: var(--text-body, #334155);\n}\n\n.gmButton--ghost:hover,\n.gmComposerButtons .gmButton--ghost:hover {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.gmButton--secondary:hover,\n.gmComposerButtons .gmButton--secondary:hover {\n  border-color: var(--border-strong, #94a3b8);\n  background: var(--slate-50, #f8fafc);\n}\n\n.gmButton:disabled,\n.gmComposerButtons button:disabled,\n.gmActionButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.gmComposerButtons {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.gmComposerButtons__left,\n.gmComposerButtons__right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.gmComposerButtons__final {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.gmScheduleField {\n  position: relative;\n  z-index: 20;\n  width: min(100%, 420px);\n  margin: 16px 0;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n}\n\n.gmScheduleField .sit-dp__pop {\n  z-index: 1200;\n}\n\n.gmActionWrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.gmActionGroup {\n  display: inline-flex;\n  border-radius: 999px;\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.08));\n}\n\n.gmActionButton {\n  border-radius: 999px 0 0 999px;\n}\n\n.gmActionToggle {\n  min-width: 36px;\n  padding: 0 12px;\n  border-radius: 0 999px 999px 0;\n  border-left-color: rgba(255, 255, 255, 0.34);\n}\n\n.gmActionDropdown {\n  position: absolute;\n  z-index: 50;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 190px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-lg, 0 18px 44px rgba(15, 23, 42, 0.16));\n}\n\n.gmActionDropdown button {\n  width: 100%;\n  justify-content: flex-start;\n  min-height: 34px;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-body, #334155);\n}\n\n.gmActionDropdown button:hover {\n  background: var(--slate-100, #f1f5f9);\n}\n\n.bProgress {\n  height: 8px;\n  border-radius: 999px;\n  background: var(--slate-100, #f1f5f9);\n  overflow: visible;\n  margin: 0;\n}\n\n.bProgress .progress-bar {\n  height: 8px;\n  border-radius: 999px;\n  background: var(--action-primary, #2563eb);\n  color: transparent;\n  min-width: 8px;\n}\n\n.gmProgressText {\n  margin-top: 8px;\n  font-size: 12px;\n  color: var(--text-muted, #64748b);\n  font-weight: 700;\n}\n\n.gmPreview {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 390px;\n  gap: 20px;\n  align-items: start;\n}\n\n.gmPreview__main,\n.gmPreview__recipients {\n  min-width: 0;\n}\n\n.gmPreview__title {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.gmPreview__heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.gmPreview__heading .sitHelpIconButton {\n  margin-left: auto;\n}\n\n.gmPreviewTabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.gmPreviewTabs__tab {\n  min-height: 34px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  border: 1.5px solid var(--border-default, #cbd5e1);\n  background: var(--slate-0, #fff);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.gmPreviewTabs__tab--active {\n  border-color: var(--action-primary, #2563eb);\n  background: var(--blue-50, #eff6ff);\n  color: var(--blue-700, #1d4ed8);\n}\n\n.gmPreviewCard {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  overflow: hidden;\n}\n\n.gmPreviewEmail__head {\n  padding: 13px 15px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n}\n\n.gmPreviewEmail__from {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  font-size: 12px;\n  color: var(--text-muted, #64748b);\n}\n\n.gmPreviewEmail__fromLabel {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.gmPreviewEmail__from strong {\n  color: var(--text-strong, #0f172a);\n  font-weight: 700;\n}\n\n.gmPreviewEmail__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--blue-100, #dbeafe);\n  color: var(--blue-700, #1d4ed8);\n  font-weight: 800;\n}\n\n.gmPreviewEmail__subject {\n  margin-top: 9px;\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--text-strong, #0f172a);\n}\n\n.gmPreviewEmail__body {\n  padding: 16px 15px;\n  min-height: 160px;\n  line-height: 1.6;\n  font-size: 13px;\n  color: var(--text-body, #334155);\n  overflow-wrap: anywhere;\n}\n\n.gmPreviewEmail__body img {\n  max-width: 100% !important;\n  height: auto !important;\n}\n\n.gmPreviewEmail__attachments {\n  padding: 12px 15px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fbfdff);\n  font-size: 12px;\n}\n\n.gmPreviewDevice {\n  max-width: 360px;\n  margin: 0 auto;\n  border-radius: 20px;\n  padding: 16px 14px 20px;\n  background: linear-gradient(160deg, #1e293b, #334155);\n}\n\n.gmPreviewDevice__time {\n  color: rgba(255, 255, 255, 0.9);\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.gmPreviewPushCard {\n  background: rgba(255, 255, 255, 0.96);\n  border-radius: 14px;\n  padding: 11px 12px;\n  box-shadow: var(--shadow-md, 0 8px 20px rgba(15, 23, 42, 0.14));\n}\n\n.gmPreviewPushCard__top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.gmPreviewPushCard__logo {\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  object-fit: contain;\n  background: #fff;\n}\n\n.gmPreviewPushCard__app {\n  flex: 1;\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted, #64748b);\n  text-transform: uppercase;\n}\n\n.gmPreviewPushCard__now {\n  font-size: 11px;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.gmPreviewPushCard__title {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--text-strong, #0f172a);\n}\n\n.gmPreviewPushCard__body {\n  margin-top: 2px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-body, #334155);\n}\n\n.gmPreviewSms {\n  padding: 16px 14px;\n  border-radius: 14px;\n  background: var(--slate-100, #f1f5f9);\n}\n\n.gmPreviewSms__sender {\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-muted, #64748b);\n  margin-bottom: 12px;\n}\n\n.gmPreviewSms__bubble {\n  max-width: 86%;\n  padding: 10px 13px;\n  border-radius: 16px 16px 16px 4px;\n  background: var(--green-500, #22c55e);\n  color: #fff;\n  font-size: 13px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.gmPreviewSms__time {\n  margin-top: 6px;\n  font-size: 11px;\n  color: var(--text-subtle, #94a3b8);\n}\n\n@media (max-width: 1100px) {\n  .gmSettings__audienceGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .gmPreview {\n    grid-template-columns: 1fr;\n  }\n}\n\n.gmComposerInlineError {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  margin-top: 18px;\n  padding: 11px 12px;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  background: #fff7f7;\n  color: #991b1b;\n}\n\n.gmComposerInlineError__icon {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #fee2e2;\n  font-size: 13px;\n  font-weight: 900;\n}\n\n.gmComposerInlineError p {\n  flex: 1 1 auto;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.45;\n}\n\n.gmComposerInlineError__actions {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 8px;\n}\n\n.gmComposerInlineError__close {\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #991b1b;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.gmComposerInlineError__close:hover {\n  background: #fee2e2;\n}\n\n@media (max-width: 1217px) {\n  .gmCreateHeader {\n    width: 100vw;\n    margin-left: -12px;\n  }\n}\n\n@media (max-width: 900px) {\n  .gmCreateHeader {\n    width: 100vw;\n    min-height: 104px;\n    align-items: flex-start;\n    margin: -16px 0 14px -16px;\n    padding: 12px 16px;\n  }\n\n  .gmCreateHeader > i,\n  .gmCreateHeader__status {\n    display: none;\n  }\n\n  .gmCreateHeader__back {\n    padding-right: 3px;\n    padding-left: 3px;\n  }\n\n  .gmCreateHeader h1 {\n    font-size: 20px;\n    line-height: 25px;\n  }\n}\n\n@media (max-width: 760px) {\n  .bCreateGeneralMessagesView {\n    padding-bottom: 24px;\n  }\n\n  .gmComposerHead {\n    align-items: flex-start;\n  }\n\n  .gmSettings__grid,\n  .gmSettings__audienceGrid,\n  .gmPriorities__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .gmSettings__help {\n    min-height: 28px;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .gmAffected__header {\n    align-items: flex-start;\n  }\n\n  .gmAffected__help > span,\n  .gmAffected__summaryDivider {\n    display: none;\n  }\n\n  .gmComposerCard--recipients .gmComposerCard__body {\n    padding: 14px;\n  }\n\n  .gmComposerButtons {\n    flex-direction: column;\n  }\n\n  .gmComposerButtons__left,\n  .gmComposerButtons__right,\n  .gmComposerButtons button {\n    width: 100%;\n  }\n}\n\n/* Follow-up alignment and overflow fixes */\n.gmSettings__grid .gmField + .gmField {\n  margin-top: 0;\n}\n\n.gmField {\n  position: relative;\n}\n\n.gmField:focus-within {\n  z-index: 120;\n}\n\n.gmVarInsert:focus-within,\n.gmVarInsert:hover {\n  z-index: 140;\n}\n\n.gmVarInsert__panel {\n  z-index: 1000;\n}\n\n.gmButton,\n.gmComposerButtons button,\n.gmActionButton,\n.gmActionDropdown button {\n  border-radius: 10px;\n}\n\n.gmActionGroup {\n  border-radius: 10px;\n}\n\n.gmActionButton {\n  border-radius: 10px 0 0 10px;\n}\n\n.gmActionToggle {\n  border-radius: 0 10px 10px 0;\n}\n\n.gmActionDropdown button {\n  border-radius: 8px;\n}\n\n.gmPreview__recipients {\n  overflow: hidden;\n}\n\n.gmRecipientsReview {\n  min-width: 0;\n  padding: 0;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  overflow: hidden;\n}\n\n.gmAffected__header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px 14px;\n}\n\n.gmAffected__header h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-size: 26px;\n  line-height: 1.2;\n  font-weight: 800;\n}\n\n.gmAffected__header p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n}\n\n.gmAffected__help {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: inline-flex;\n}\n\n.gmAffected__summary {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0 24px 14px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: var(--surface-sunken, #f8fafc);\n  flex-wrap: wrap;\n}\n\n.gmAffected__summary > strong,\n.gmAffected__totalMetric {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  padding: 4px 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.gmAffected__totalMetric {\n  cursor: pointer;\n}\n\n.gmAffected__totalMetric.is-active {\n  border-color: var(--blue-500, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.gmAffected__summaryDivider {\n  width: 1px;\n  height: 22px;\n  background: var(--border-default, #cbd5e1);\n}\n\n.gmAffected__summaryChannels {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n\n.gmAffected__summaryChannels > span,\n.gmAffected__summaryChannels > button {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 9px 3px 4px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.gmAffected__summaryChannels > button {\n  cursor: pointer;\n}\n\n.gmAffected__summaryChannels > button:hover:not(:disabled) {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--blue-50, #eef6fc);\n}\n\n.gmAffected__summaryChannels > button.is-active {\n  border-color: var(--blue-500, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.gmAffected__summaryChannels > button:disabled {\n  cursor: default;\n  opacity: 0.62;\n}\n\n.gmAffected__summaryChannels > em,\n.gmAffected__delivery {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.gmAffected__summaryChannels > em {\n  min-height: 30px;\n  padding-right: 10px;\n  padding-left: 10px;\n  background: var(--amber-100, #fef3c7);\n  color: var(--amber-800, #92400e);\n  white-space: nowrap;\n}\n\n.gmAffected__summaryChannels > button.is-no-channels {\n  padding-right: 10px;\n  padding-left: 10px;\n  background: var(--amber-100, #fef3c7);\n  color: var(--amber-800, #92400e);\n}\n\n.gmAffected__summaryChannels > button.is-no-channels.is-active {\n  border-color: #f3c46b;\n  background: #ffe9c2;\n}\n\n.gmAffected__loadButton {\n  min-height: 34px;\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.gmAffected__channel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n}\n\n.gmAffected__channel--active {\n  background: var(--status-success-bg, #dcfce7);\n  color: var(--status-success-fg, #15803d);\n}\n\n.gmAffected__loading,\n.gmAffected__empty,\n.gmAffected__emptyText {\n  margin: 0 24px 20px;\n  padding: 18px;\n  border-radius: 12px;\n  background: var(--surface-sunken, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.gmAffected__recipient {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.gmAffected__recipient > strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.gmAffected__roles {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n\n.gmAffected__roles > span {\n  display: inline-flex;\n  min-height: 24px;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.gmAffected__roles > span.is-unknown {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.gmAffected__listMeta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 24px 10px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.gmAffected__listMeta button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.gmAffected__listMeta button:hover {\n  text-decoration: underline;\n}\n\n.gmAffected__avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  overflow: hidden;\n  border-radius: 50%;\n  background: var(--blue-100, #dbeafe);\n  color: var(--blue-700, #1d4ed8);\n  font-size: 11px;\n  font-weight: 800;\n  flex: 0 0 auto;\n}\n\n.gmAffected__avatar img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.gmAffected__delivery--success {\n  background: var(--status-success-bg, #dcfce7);\n  color: var(--status-success-fg, #15803d);\n}\n\n.gmAffected__delivery--danger {\n  background: var(--status-danger-bg, #fee2e2);\n  color: var(--status-danger-fg, #b91c1c);\n}\n\n.gmAffected__channelCell {\n  width: 90px;\n  text-align: center !important;\n}\n\n.gmAffected__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n}\n\n.gmAffected__head span,\n.gmAffected__empty,\n.gmAffected__emptyText {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.gmAffected__empty {\n  margin-top: 10px;\n}\n\n.gmAffected__empty p {\n  margin: 0 0 10px;\n  line-height: 1.45;\n}\n\n.gmAffected__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.gmAffected__stats span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 4px 9px;\n  border-radius: 8px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.gmAffected__tableWrap {\n  width: 100%;\n  max-width: 100%;\n  max-height: 420px;\n  margin: 0 24px 20px;\n  width: auto;\n  overflow: auto;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n}\n\n.gmAffected__table {\n  width: 100%;\n  min-width: 720px;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n  font-size: 12px;\n}\n\n.gmAffected__table th,\n.gmAffected__table td {\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  text-align: left;\n  vertical-align: top;\n  overflow-wrap: anywhere;\n}\n\n.gmAffected__table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.gmAffected__table tr:last-child td {\n  border-bottom: 0;\n}\n\n.gmAffected__channel svg {\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.gmComposerCard--recipients .gmAffected__table tbody tr:nth-child(even) {\n  background: var(--slate-50, #f8fafc);\n}\n\n.gmPreview--single {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.gmAffectedScreen {\n  width: min(1100px, 100%);\n  max-width: 1100px;\n  margin: 0;\n}\n\n.gmComposerCard--recipients {\n  width: min(1100px, 100%);\n  max-width: 1100px;\n  margin: 0;\n}\n\n.gmComposerCard--recipients .gmComposerCard__body {\n  padding: 24px 28px;\n}\n\n.gmComposerCard--recipients .gmRecipientsReview {\n  border: 0;\n  border-radius: 0;\n  overflow: visible;\n}\n\n.gmComposerCard--recipients .gmAffected__header {\n  padding: 0 0 20px;\n}\n\n.gmComposerCard--recipients .gmAffected__summary,\n.gmComposerCard--recipients .gmAffected__listMeta,\n.gmComposerCard--recipients .gmAffected__tableWrap,\n.gmComposerCard--recipients .gmAffected__loading,\n.gmComposerCard--recipients .gmAffected__empty,\n.gmComposerCard--recipients .gmAffected__emptyText {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.gmAffectedScreen .gmAffected__tableWrap {\n  max-height: 560px;\n}\n\n.gmAffectedScreen .gmAffected__table {\n  min-width: 760px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
